var _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunPath(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140mm",
    height: "140mm",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56.568 102.39-32.265 11.5-17.945-2.3926 11.238-11.607 51.962-20z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.578 94.895v-10l12.99 7.5v10z",
    fill: "#c7c7c7",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.568 92.395 25.981-15v10l-25.981 15",
    fill: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.568 92.395-4.3301-12.5-8.6602 5",
    fill: "#c7c7c7",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.238 79.895 25.981-15 4.3301 12.5-25.981 15z",
    fill: "#fffefe",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.568 92.395v10",
    fill: "#c7c7c7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.578 84.895 12.99 7.5",
    fill: "#c7c7c7",
    strokeLinecap: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.774 94.895 2.5981 1.5v-4l-2.5981-1.5v4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.764 96.395v-4l2.5981-1.5v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.523 1.0934a216.48 216.48 0 0 1 84.234 74.947",
    strokeDasharray: "6.00001, 6.00001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.621 89.395v-4l2.5981-1.5v4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-83.391 -49.914)",
    d: "m199.19 102.9c-0.0528 0.022-3.8213-4.7914-3.8783-4.7868-0.057 0.0046-3.0075 5.3585-3.0632 5.3453-0.0556-0.0132-0.27518-6.1225-0.32399-6.1523-0.0488-0.0298-5.5828 2.5674-5.62 2.524-0.0372-0.04342 3.3761-5.1149 3.3541-5.1677-0.022-0.0528-6.0257-1.2044-6.0302-1.2615-5e-3 -0.05701 5.7378-2.1537 5.751-2.2093 0.0133-0.05563-4.1669-4.5162-4.1371-4.565 0.0298-0.04881 5.9078 1.6302 5.9513 1.593 0.0434-0.03722-0.71653-6.1029-0.66373-6.1249 0.0528-0.02198 3.8213 4.7914 3.8783 4.7868 0.057-0.0046 3.0075-5.3586 3.0632-5.3453 0.0556 0.01325 0.27518 6.1225 0.324 6.1523 0.0488 0.0298 5.5828-2.5674 5.62-2.524 0.0372 0.04342-3.3761 5.1149-3.3541 5.1677 0.022 0.0528 6.0257 1.2044 6.0302 1.2615 5e-3 0.05701-5.7378 2.1537-5.751 2.2093-0.0132 0.05563 4.1669 4.5162 4.1371 4.565-0.0298 0.04881-5.9078-1.6302-5.9513-1.593-0.0434 0.03722 0.71654 6.1029 0.66374 6.1249z",
    fill: "#ff0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunPath);
export default __webpack_public_path__ + "static/media/sun_path.878a70fb7791417d2c78e9e3973b4400.svg";
export { ForwardRef as ReactComponent };